import {DimensionUomCd} from '../';
import {EnumHelper} from './enum-helper';

export class DimensionUomCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in DimensionUomCd ) {
      this._values.push(DimensionUomCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): DimensionUomCd {

    for ( const obj in DimensionUomCd ) {
      if (DimensionUomCd[obj] === value){
        return DimensionUomCd[obj] as DimensionUomCd;
      }
    }
  }
}

const DimensionUomCdHelper = new DimensionUomCdHelperEnumHelperClass();
export default DimensionUomCdHelper;
